import __request__ from 'routing/request';
interface MimecastCreateInputRequest {
    readonly secret_key: unknown;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly content_type: string[];
    readonly access_key: string;
    readonly name: string;
    readonly base_url: string;
    readonly application_id: string;
    readonly application_key: unknown;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface MimecastRequestImpl {
    readonly secret_key: unknown;
    readonly access_key: string;
    readonly base_url: string;
    readonly application_id: string;
    readonly application_key: unknown;
}
/**
 * Validate API Credentials
 */
export function checkCredentials(JSONbody: MimecastRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.mimecast.api.MimecastResource/mimecast/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Mimecast input
 */
export function create(JSONbody: MimecastCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.mimecast.api.MimecastResource/mimecast/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
